export default __webpack_public_path__ + "static/CRIMEANDPEPESHMENT-f4ad88a232b591e98453bd8d165d91ae.png";